'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ReviewsAppIcon = function ReviewsAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 11.21 10.8",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("polygon", {
    points: "3.38 1.55 3.38 6.86 5.97 8.26 5.97 7.5 5.97 6.69 5.97 1.76 5.97 0.95 5.97 0.02 3.38 1.55"
  }), React__default["default"].createElement("polygon", {
    points: "7.82 7.49 6.72 7.49 6.72 6.87 7.2 6.87 7.22 1.53 6.72 1.53 6.72 0.91 7.84 0.91 7.82 7.49"
  }), React__default["default"].createElement("polygon", {
    points: "5.61 9.04 5.89 9.62 6.52 9.71 6.07 10.15 6.17 10.78 5.61 10.48 5.04 10.78 5.15 10.15 4.7 9.71 5.33 9.62 5.61 9.04"
  }), React__default["default"].createElement("polygon", {
    points: "7.95 9.04 8.23 9.62 8.86 9.71 8.4 10.15 8.51 10.78 7.95 10.48 7.38 10.78 7.49 10.15 7.03 9.71 7.66 9.62 7.95 9.04"
  }), React__default["default"].createElement("polygon", {
    points: "0.93 9.04 1.22 9.62 1.85 9.71 1.39 10.15 1.5 10.78 0.93 10.48 0.37 10.78 0.48 10.15 0.02 9.71 0.65 9.62 0.93 9.04"
  }), React__default["default"].createElement("polygon", {
    points: "3.27 9.04 3.55 9.62 4.18 9.71 3.73 10.15 3.84 10.78 3.27 10.48 2.71 10.78 2.81 10.15 2.36 9.71 2.99 9.62 3.27 9.04"
  }), React__default["default"].createElement("polygon", {
    points: "10.28 9.04 10.57 9.62 11.2 9.71 10.74 10.15 10.85 10.78 10.28 10.48 9.72 10.78 9.83 10.15 9.37 9.71 10 9.62 10.28 9.04"
  }));
};

var ReviewsAppIcon$1 = iconStyles()(ReviewsAppIcon);

module.exports = ReviewsAppIcon$1;
